import { default as CommentEditor } from './CommentEditor';
import { default as CommentTiptapEditor } from '../CommentEditor.editor_v3';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    editor_comment: CommentTiptapEditor
})(CommentEditor);

//# sourceMappingURL=index.js.map